import * as React from "react";

import { type RootContainerProps } from "@client/content/types";
import ItemContainer from "../Item/container";

export type ImageGalleryComponentProps = RootContainerProps & {
  itemsIds: string[];
};
export default ({ itemsIds, ...props }: ImageGalleryComponentProps) => (
  <div className="thumbnail_list">
    {itemsIds.map((itemId) => (
      <ItemContainer key={itemId} {...props} parentId={props.id} id={itemId} />
    ))}
  </div>
);
